// src/services/api/mlbApi.js
import { rootApi } from './rootApi';

export const mlbApi = rootApi.injectEndpoints({
    endpoints: (build) => ({
        getMlbUpcomingGames: build.query({
            query: () => '/mlb/upcoming',
            keepUnusedDataFor: 60, // 1 minute cache
            providesTags: () => [{ type: 'UpcomingGames', id: 'MLB' }],
        }),
        getMlbStadiumOrientations: build.query({
            query: () => '/mlb/venue_orientations',
            keepUnusedDataFor: 60, // 1 minute cache
            providesTags: () => [{ type: 'StadiumOrientations', id: 'MLB' }],
        }),
        getMlbGameScores: build.query({
            query: ({ homeTeam, awayTeam }) => 
                `/gateway/mlb-linescores?home=${homeTeam}&away=${awayTeam}`,
            keepUnusedDataFor: 60, // 1 minute cache
            providesTags: (result, error, { homeTeam, awayTeam }) => [
                { type: 'GameScores', id: `MLB-${homeTeam}-${awayTeam}` }
            ],
        })
    }),
  overrideExisting: false,
});

export const { 
    useGetMlbUpcomingGamesQuery,
    useGetMlbStadiumOrientationsQuery,
    useGetMlbGameScoresQuery
} = mlbApi;